import React from "react";
import { CircleDot, Grid2X2, Languages, Layers, Rows3, Search, X } from "lucide-react";
import { WsDropdown, WsSegmented } from "src/stage/WsControls";

// AUTO-WA-39: the shared Stage controls (custom dropdowns, segmented view switch).
const CATEGORY_OPTIONS = [
  { value: "ALL", label: "All categories", short: "All" },
  { value: "MARKETING", label: "Marketing" },
  { value: "UTILITY", label: "Utility" },
  { value: "AUTHENTICATION", label: "Authentication" },
];

const STATUS_OPTIONS = [
  { value: "ALL", label: "All statuses", short: "All" },
  { value: "APPROVED", label: "Approved", dot: "live" },
  { value: "PENDING", label: "Pending", dot: "info" },
  { value: "REJECTED", label: "Rejected", dot: "failed" },
  { value: "PAUSED", label: "Paused", dot: "paused" },
  { value: "DISABLED", label: "Disabled", dot: "draft" },
];

const VIEWS = [
  { id: "cards", label: "Cards", icon: Grid2X2 },
  { id: "table", label: "Table", icon: Rows3 },
];

const TemplateFilters = ({ search, setSearch, category, setCategory, language, setLanguage, status, setStatus, languages = [], resultCount = 0, viewMode = "cards", setViewMode }) => {
  const hasFilters = Boolean(search.trim()) || category !== "ALL" || language !== "ALL" || status !== "ALL";
  const languageOptions = [{ value: "ALL", label: "All languages", short: "All" }, ...languages.map((code) => ({ value: code, label: code }))];

  const clearFilters = () => {
    setSearch("");
    setCategory("ALL");
    setLanguage("ALL");
    setStatus("ALL");
  };

  return (
    <div className="ws-controls wa-tpl-filters">
      <WsSegmented label="Template view" items={VIEWS} value={viewMode} onChange={(value) => setViewMode?.(value)} />
      <span className="ws-muted">{resultCount.toLocaleString("en-IN")} {resultCount === 1 ? "template" : "templates"}</span>
      <div className="ws-controls-end">
        <label className="ws-searchbox">
          <Search size={15} aria-hidden="true" />
          <input type="search" placeholder="Search templates" value={search} onChange={(event) => setSearch(event.target.value)} aria-label="Search templates" />
        </label>
        <WsDropdown label="Category" icon={Layers} value={category} options={CATEGORY_OPTIONS} onChange={setCategory} />
        <WsDropdown label="Language" icon={Languages} value={language} options={languageOptions} onChange={setLanguage} />
        <WsDropdown label="Status" icon={CircleDot} value={status} options={STATUS_OPTIONS} onChange={setStatus} align="right" />
        {hasFilters && (
          <button type="button" className="ws-btn ws-btn--plain" onClick={clearFilters}><X size={14} />Reset</button>
        )}
      </div>
    </div>
  );
};

export default TemplateFilters;
